export default __webpack_public_path__ + "static/media/small-2.3274ad33.jpg";